export enum PayloadstagingDocumentType {
    UNKN = 'UNKN',
    SRF = 'SRF',
    COR = 'COR',
    INC = 'INC',
    CLM = 'CLM',
    ENR = 'ENR',
    PA = 'PA',
    AOB = 'AOB',
    OTHER = 'OTHER'
}

(PayloadstagingDocumentType as any)['UNKN'] = 'UNKN';
(PayloadstagingDocumentType as any)['SRF'] = 'SRF';
(PayloadstagingDocumentType as any)['COR'] = 'COR';
(PayloadstagingDocumentType as any)['INC'] = 'INC';
(PayloadstagingDocumentType as any)['CLM'] = 'CLM';
(PayloadstagingDocumentType as any)['ENR'] = 'ENR';
(PayloadstagingDocumentType as any)['PA'] = 'PA';
(PayloadstagingDocumentType as any)['AOB'] = 'AOB';
(PayloadstagingDocumentType as any)['OTHER'] = 'OTHER';

